import React from "react";
import ReactDOM from "react-dom";

import { Provider } from "react-redux";
import store from "./store";

import { Router, Route, Switch } from "react-router-dom";
import history from "./history";

import Srp from "./components/search/search";
import Checkout from "./components/checkout/checkout";
import CheckoutNew from "./components/checkout/checkoutNew";
import CheckoutNew2 from "./components/checkout/checkoutNew2";
import CheckoutNew3 from "./components/checkout/checkoutNew3";
import Success from "./components/success/success";
import Login from "./components/login";
import ManageAccount from "./components/manageAccount";
// import CancelDetails from "./components/cancel/cancelDetails";
import GuestCancel from "./components/guestCancel/guestCancel";
import HelpAndSupport from "./components/helpAndSupport/helpAndSupport";
import GuestCancelConfirm from "./components/guestCancel/guestCancelConfirm";
import GuestEdit from "./components/guestEdit/guestEdit";
import GuestEditConfirm from "./components/guestEdit/guestEditConfirm";
// import BusTicketBooking from "./components/manageAccount/BusTicketBooking";

import TimeTable from "./components/timetable";
import TimeTableResult from "./components/timetable/Result";
import BookingEnquiry from "./components/bookingEnquiry";
import AboutUs from "./components/aboutus/index";
import FeedbackSubmit from "./components/feedback/FeedbackSubmit";
import Feedback from "./components/feedback/Feedback";

import "./styles/main.scss";
import Branch from "./components/branch";
import SearchTourBooking from "./components/search_tour_booking";

ReactDOM.render(
  <Provider store={store}>
    <Router history={history}>
      <Switch>
        <Route path="/search/" component={Srp} />
        <Route path="/co/exp/:token" component={CheckoutNew3} />
        <Route path="/success/:token" component={Success} />
        <Route path="/login/" component={Login} />
        <Route path="/account" component={ManageAccount} />
        <Route path="/manageBusBooking" component={ManageAccount} />
        <Route path="/guest-cancel" component={GuestCancel} />
        <Route path="/help-and-support" component={HelpAndSupport} />
        <Route path="/cancel_guest" component={GuestCancel} />
        <Route path="/guest-cancel-confirm" component={GuestCancelConfirm} />
        <Route path="/guest-edit" component={GuestEdit} />
        <Route path="/edit_guest" component={GuestEdit} />
        <Route path="/guest-edit-confirm" component={GuestEditConfirm} />
        <Route exact path="/time_table" component={TimeTable} />
        <Route exact path="/time_table/result" component={TimeTableResult} />
        <Route exact path="/booking-enquiry" component={BookingEnquiry} />
        <Route exact path="/status" component={BookingEnquiry} />
        <Route path="/about_us" component={AboutUs} />
        <Route path="/history" component={AboutUs} />
        <Route path="/bus_services" component={AboutUs} />
        <Route path="/key_statistics" component={AboutUs} />
        <Route path="/labour_welfare" component={AboutUs} />
        <Route path="/infrastructure_facility" component={AboutUs} />
        <Route path="/procurement" component={AboutUs} />
        <Route path="/annual_administration_report" component={AboutUs} />
        <Route path="/passenger_safety" component={AboutUs} />
        <Route path="/letters_and_circulars" component={AboutUs} />
        <Route path="/luggage_rates" component={AboutUs} />
        <Route path="/reservation_terms" component={AboutUs} />
        <Route path="/reservation-terms" component={AboutUs} />
        <Route path="/guest_users_terms" component={AboutUs} />
        <Route path="/guest-users-terms" component={AboutUs} />
        <Route path="/refund_rules_and_claims" component={AboutUs} />
        <Route path="/refund-rules-and-claims" component={AboutUs} />
        <Route path="/booking_counters" component={AboutUs} />
        <Route path="/passes_and_concession" component={AboutUs} />
        <Route path="/new-franchisee-procedure" component={AboutUs} />
        <Route path="/casual-contact" component={AboutUs} />
        <Route path="/checkout/franchiseeRecharge/:token" component={Branch} />
        <Route exact path = "/feedback/submit" component = {FeedbackSubmit} />
        <Route exact path = "/feedback" component={Feedback} />
        <Route path="/search_tour_booking/" component={SearchTourBooking} />
      </Switch>
    </Router>
  </Provider>,
  document.getElementById("root")
);

// registerServiceWorker();

// images
// min height
// routing
